import { PropsWithChildren } from 'react';

import {
  ChakraBox,
  ChakraFlex,
  FAIconName,
  FireflyButton,
  ModalV2,
  Text,
  ToastMessage,
} from '@equip.health/ui';
import { GENERIC_API_FAILURE_MESSAGE } from '~/lib/constants/profile.constants';

interface DeleteConfirmationModalProps extends PropsWithChildren {
  buttonTitle: string;
  isErrorToastVisible?: boolean;
  isOpen: boolean;
  isPrimaryButtonDisabled: boolean;
  onConfirmClick: () => void;
  setIsOpen: (isOpen: boolean) => void;
  subTitle: string;
  title: string;
}

const TOP_LEVEL_ID = 'delete-confirm-modal';

const DeleteConfirmModal = ({
  buttonTitle,
  isErrorToastVisible,
  isOpen,
  isPrimaryButtonDisabled,
  onConfirmClick,
  setIsOpen,
  subTitle,
  title,
}: DeleteConfirmationModalProps) => {
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <ModalV2
      footerContent={
        <ChakraFlex justifyContent="space-between" width="100%">
          <FireflyButton
            id={`${TOP_LEVEL_ID}__delete-bp`}
            leftIcon={FAIconName.XmarkRegular}
            onClick={handleClose}
            variant="secondary"
          >
            Cancel
          </FireflyButton>

          <FireflyButton
            id={`${TOP_LEVEL_ID}__cancel-deletion`}
            isLoading={isPrimaryButtonDisabled}
            leftIcon={FAIconName.trashRegular}
            onClick={() => {
              onConfirmClick();
            }}
            variant="accent.critical"
          >
            {buttonTitle}
          </FireflyButton>
        </ChakraFlex>
      }
      id={TOP_LEVEL_ID}
      isOpen={isOpen}
      onClose={handleClose}
      title={
        <Text id={`${TOP_LEVEL_ID}__title`} variant="h4">
          {title}
        </Text>
      }
    >
      <Text
        color="neutral.primary"
        id={`${TOP_LEVEL_ID}__subtitle`}
        variant="body"
      >
        {subTitle}
      </Text>
      {isErrorToastVisible && (
        <ChakraBox marginTop="12px">
          <ToastMessage
            icon={FAIconName.exclamationTriangleRegular}
            id={`${TOP_LEVEL_ID}__warning`}
            isFullWidth
            text={GENERIC_API_FAILURE_MESSAGE}
            variant="critical"
          />
        </ChakraBox>
      )}
    </ModalV2>
  );
};

export default DeleteConfirmModal;
